import React from 'react';
import {createBrowserRouter} from 'react-router-dom';
import AuthorizedLayout from '../layouts/AuthorizedLayout';
import Dashboard from 'components/dashboard';
import EditPage from 'components/form/whitelabel';
import Publishers from '../containers/Publishers';
import CreatePublisher from '../containers/Publishers/CreatePublisher';
import Endpoints from '../containers/Endpoints';
import EndpointEditPage from 'components/form/endpoint';
import AnalyticsReportPage from 'components/reports/analytics';
import BalancesReportPage from 'components/reports/balances';
import ClientTransactions from '../containers/Transactions/ClientTransactions';
import PublisherPayments from '../containers/Transactions/PublisherPayments';
import TopUpRequests from '../containers/Transactions/TopUpRequests';
import DashboardLayout from '../layouts/DashboardLayout';
import SignIn from 'components/form/login';
import UserProfile from '../containers/User/UserProfile';
import UserManagement from '../containers/User/UserManagement';
import UserEdit from '../containers/User/UserEdit';
import AuthCheck from 'components/common/AuthCheck';
import {PERMISSIONS} from '../constants';
import NotFound from '../containers/NotFound';

const routes = [
    {
        element: <AuthorizedLayout />,
        children: [
            {
                // authorized routes
                element: <DashboardLayout />,
                children: [
                    {path: '/', element: <></>},
                    {
                        element: <AuthCheck component={Dashboard} permissions={[PERMISSIONS.CLIENTS_READ, PERMISSIONS.CLIENTS_MANAGEMENT]} />,
                        path: '/dashboard',
                    },
                    {
                        element: <AuthCheck component={EditPage} permissions={[PERMISSIONS.CLIENTS_MANAGEMENT, PERMISSIONS.CLIENTS_READ]} everyPermission />,
                        path: '/create',
                    },
                    {
                        element: <AuthCheck component={EditPage} permissions={[PERMISSIONS.CLIENTS_READ, PERMISSIONS.CLIENTS_MANAGEMENT]} />,
                        path: '/update/:id',
                    },
                    {
                        path: '/publishers',
                        children: [
                            {path: '', element: <AuthCheck component={Publishers} permissions={[PERMISSIONS.PUBLISHERS_READ, PERMISSIONS.PUBLISHERS_MANAGEMENT]} />},
                            {path: 'create', element: <AuthCheck component={CreatePublisher} permissions={[PERMISSIONS.PUBLISHERS_MANAGEMENT, PERMISSIONS.PUBLISHERS_READ]} everyPermission />},
                            {path: ':id/edit', element: <AuthCheck component={CreatePublisher} permissions={[PERMISSIONS.PUBLISHERS_READ, PERMISSIONS.PUBLISHERS_MANAGEMENT]} />},
                        ],
                    },
                    {
                        path: '/endpoints',
                        children: [
                            {path: '', element: <AuthCheck component={Endpoints} permissions={[PERMISSIONS.PUBLISHERS_READ, PERMISSIONS.PUBLISHERS_MANAGEMENT]} />},
                            {path: 'create', element: <AuthCheck component={EndpointEditPage} permissions={[PERMISSIONS.PUBLISHERS_MANAGEMENT, PERMISSIONS.PUBLISHERS_READ]} everyPermission />},
                            {path: ':id/edit', element: <AuthCheck component={EndpointEditPage} permissions={[PERMISSIONS.PUBLISHERS_MANAGEMENT, PERMISSIONS.PUBLISHERS_READ]} />},
                        ],
                    },
                    {
                        path: '/reports',
                        children: [
                            {path: 'analytics', element: <AuthCheck component={AnalyticsReportPage} permissions={PERMISSIONS.ANALYTICS_REPORT_READ} />},
                            {path: 'balances', element: <AuthCheck component={BalancesReportPage} permissions={PERMISSIONS.BALANCES_REPORT_READ} />},
                        ],
                    },
                    {
                        path: '/transactions',
                        children: [
                            {path: 'clients', element: <AuthCheck component={ClientTransactions} permissions={[PERMISSIONS.TRANSACTIONS_READ, PERMISSIONS.TRANSACTIONS_MANAGEMENT]} />},
                            {path: 'publishers', element: <AuthCheck component={PublisherPayments} permissions={[PERMISSIONS.TRANSACTIONS_READ, PERMISSIONS.TRANSACTIONS_MANAGEMENT]} />},
                            {path: 'top-up-requests', element: <AuthCheck component={TopUpRequests} permissions={[PERMISSIONS.TRANSACTIONS_READ, PERMISSIONS.TRANSACTIONS_MANAGEMENT]} />},
                        ],
                    },
                    {path: '/users',
                        children: [
                            {path: '', element: <AuthCheck component={UserManagement} permissions={PERMISSIONS.USER_MANAGEMENT} />},
                            {path: ':id/edit', element: <AuthCheck component={UserEdit} permissions={PERMISSIONS.USER_MANAGEMENT} />},
                            {path: 'create', element: <AuthCheck component={UserEdit} permissions={PERMISSIONS.USER_MANAGEMENT} />},
                        ],
                    },
                    {path: '/profile', element: <UserProfile />},
                ],
            },
        ],
    },
    {element: <SignIn />, path: '/login'},
    {element: <NotFound />, path: '/*'},
];
const router = createBrowserRouter(routes);
export default router;
